import {Component, EventEmitter, Input, Output} from '@angular/core';

import {SelectCustomEvent} from '@ionic/angular';
@Component({
    selector: 'app-select-type-installazione',
    templateUrl: './select-type-installazione.component.html',
    styleUrls: ['./select-type-installazione.component.scss'],
    standalone: false
})
export class SelectTypeInstallazioneComponent {
  @Input() typeInstallazione: number;
  @Output() typeInstallazioneChange = new EventEmitter<number>();
  public installazioneTypes =
    [
      { value: 1, text: 'Locale' },
      { value: 2, text: 'Cloud' },
      { value: 3, text: 'Standalone' }
    ];
  selectTypeInstallazione = (e: SelectCustomEvent) => this.typeInstallazioneChange.emit(+e.target.value);
}
